module.exports = __webpack_public_path__ + "static/media/Mayo Clinic_1602605094211.befc1ec6.m4a";